import {
    SOURCE_ITEM_RESPONSE,
    SOURCE_ITEM_SAVE_RESPONSE,
    SOURCE_LIST_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { normalise } from "../../models/entities/source"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data, receivedAt } = action
    switch (type) {
        case SOURCE_ITEM_SAVE_RESPONSE:
        case SOURCE_ITEM_RESPONSE:
            const { id } = data
            return {
                ...state,
                [id]: {
                    ...normalise(data),
                    lastUpdatedAt: receivedAt
                }
            }
        case SOURCE_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
